var _path, _ellipse, _path2, _ellipse2, _path3, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.198 5.417c0-.344.263-.625.587-.625H17.47c.324 0 .587.28.587.625 0 .343-.263.624-.587.624H4.785c-.324 0-.587-.28-.587-.625Z",
    fill: "#5D5BEA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.446,
    cy: 5.417,
    rx: 1.516,
    ry: 1.458,
    fill: "#fff",
    stroke: "#5D5BEA",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.198 10c0-.344.263-.625.587-.625H17.47c.324 0 .587.281.587.625s-.263.625-.587.625H4.785c-.324 0-.587-.281-.587-.625Z",
    fill: "#5D5BEA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.809,
    cy: 10,
    rx: 1.516,
    ry: 1.458,
    fill: "#fff",
    stroke: "#5D5BEA",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.785 13.958H17.47c.324 0 .587.281.587.625s-.263.625-.587.625H4.785c-.324 0-.587-.281-.587-.625s.263-.625.587-.625Z",
    fill: "#5D5BEA"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.446,
    cy: 14.583,
    rx: 1.516,
    ry: 1.458,
    fill: "#fff",
    stroke: "#5D5BEA",
    strokeWidth: 1.2
  })));
};
export default SvgFilter;